var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maps"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"100%","height":"100%","src":'https://www.google.com/maps/embed/v1/place?q=' + _vm.placeId + '&key=' + _vm.apiKey,"allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }